import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../environment.ts/environment';

/**
 * Interface for requesting data deletion
 */
export interface RequestDeletionRequest {
  email: string;
  idSite: number;
}

/**
 * Interface for requesting data deletion response
 */
export interface RequestDeletionResponse {
  success: boolean;
  message: string;
}

/**
 * Interface pour la suppression des données client
 */
export interface DeleteClientDataRequest {
  email: string;
  origine: string;
}

/**
 * Interface pour la réponse de suppression des données client
 */
export interface DeleteClientDataResponse {
  success: boolean;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class RemoveService {
  constructor(private http: HttpClient) {}

  /**
   * Requests client data deletion (sends confirmation email)
   * @param data - Deletion request data
   * @returns Observable with the API response
   */
  requestDeletion(data: RequestDeletionRequest): Observable<RequestDeletionResponse> {
    console.log('Demande de suppression données avec les données:', JSON.stringify(data, null, 2));
    
    return this.http.post<RequestDeletionResponse>(
      `${environment.apiBaseUrl}/clients/request-deletion`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
        }
      }
    ).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Erreur demande suppression données:', {
          status: error.status,
          data: error.error,
        });
        
        const errorMessage = error.error && typeof error.error === 'object' && 'message' in error.error
          ? String(error.error.message)
          : 'Erreur lors de la demande de suppression des données';
        
        return throwError(() => new Error(errorMessage));
      })
    );
  }

  /**
   * Suppression des données client
   * @param data - Données de suppression client
   * @returns Observable avec la réponse de l'API
   */
  deleteClientData(data: DeleteClientDataRequest): Observable<DeleteClientDataResponse> {
    console.log('Suppression données client avec les données:', JSON.stringify(data, null, 2));
    
    return this.http.delete<DeleteClientDataResponse>(
      `${environment.apiBaseUrl}/clients/delete/${encodeURIComponent(data.email)}`,
      {
        headers: {
          'Content-Type': 'application/json',
        }
      }
    ).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Erreur suppression données client:', {
          status: error.status,
          statusText: error.statusText,
          data: error.error,
        });
        
        const errorMessage = error.error && typeof error.error === 'object' && 'message' in error.error
          ? String(error.error.message)
          : 'Erreur lors de la suppression des données client';
        
        return throwError(() => new Error(errorMessage));
      })
    );
  }
}
